module.exports = __webpack_public_path__ + "static/media/banff-8.209bc28f.jpg";